import cookies from "services-comun/modules/browser/cookies";
import {CMP_META_COOKIE} from "./cmp/cmp";
import {decodeBase64BigEndian, encodeBase64BigEndian, fillZeroL} from "./util/binary";

class Metadata {

    /* STATIC */
    public static UNDEFINED:number = 31;

    /* INSTANCE */
    private _acceptanceLevel: number = Metadata.UNDEFINED;

    public constructor() {
        // Cargamos la cookie
        const cookie: string|undefined = cookies.get(CMP_META_COOKIE);
        if (cookie) {
            // Decodificar
            const binaryString: string = decodeBase64BigEndian(cookie);
            // Los primeros 5 bits representan el nivel de aceptación
            this.acceptanceLevel = parseInt(binaryString.substr(0,5), 2);
        }
    }

    public get acceptanceLevel() : number {
        return this._acceptanceLevel;
    }

    public set acceptanceLevel(level: number) {
        this._acceptanceLevel = level;
    }

    public save() : void {
        let value:string = `${fillZeroL(this.acceptanceLevel.toString(2), 5)}`;
        cookies.set(CMP_META_COOKIE, encodeBase64BigEndian(value), new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)));
    }
}

let instance: Metadata|null = null;
export default (): Metadata => {
    return instance??=new Metadata();
}
